<template>
  <div :class="['step', {'first': first, 'last': last, 'disabled': to === '#'}]">
    <div class="relative">
      <div :class="['progress', step.completed ? 'bg-success' : 'bg-todo']"></div>
      <router-link :to="to" :class="['ball text-success', step.completed ? 'completed' : '']" v-if="step.completed">
        <i class="fa fa-futbol" v-if="last"></i>
        <i class="fa fa-check" v-else></i>
      </router-link>
      <router-link :to="to" class="ball" v-else>{{ step.step }}</router-link>
    </div>
    <router-link :to="to" class="label">{{ step.label }}</router-link>
    <div v-if="last" :class="['progress last', step.completed ? 'bg-success' : 'bg-todo']"></div>
  </div>
</template>

<script>
export default {
  name: 'Step',
  props: {
    step: {
      type: Object,
      default: null,
    },
    to: {
      type: [String, Object],
      default: '#',
    },
    first: {
      type: Boolean,
      default: false,
    },
    last: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  methods: {},
  mounted() { },
};
</script>

<style lang="scss" scoped>
.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  &.disabled {
    a {
      text-decoration: none;
      cursor: default;
      color: #b0b0b0;
    }
  }
  .bg-todo {
    background: #ADB2B1;
  }
  .progress {
    top: 20%;
    position: absolute;
    z-index: 15;
    border-radius: 0;
    height: 5px;
    width: 100%;
    left: -60%;
  }
  &.first {
    .progress {
      width: 50%;
      left: 0;
      z-index: 17;
    }
  }
  &.last {
    .progress.last {
      width: 50%;
      right: 0;
      left: auto;
    }
    .ball.completed {
      box-shadow: 0px 0px 25px #99cc33;
      .fa-futbol {
        font-size: 54px;
      }
    }
  }
  .ball {
    font-size: 20px;
    font-weight: bold;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 4px 5px 0px rgba(0, 0, 0, .25);
    position: relative;
    z-index: 17;
    &:hover {
      text-decoration: none;
    }
  }
  .label {
    width: 100px;
    height: 28px;
    margin-top: 10px;
    font-size: 11px;
    line-height: 14px;
    padding-inline: 10px;
    text-align: center;
  }
}
</style>
